import useIsDesktop from "@hooks/useIsDesktop"
import useRouter from "@hooks/useRouter"

import { faIcon } from "@utils/faIcon"
import isModKeyPressed from "@utils/isModKeyPressed"

import { Button } from "@atoms"

import { NavTopBarCTAButtonProps } from "./NavTopBarCTAButton.types"

export default function NavTopBarCTAButton(props: NavTopBarCTAButtonProps) {
    const { destination } = props

    const router = useRouter()

    const isDesktop = useIsDesktop()

    const onClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (isModKeyPressed(event)) {
            window.open(destination, "_blank", "noopener,noreferrer")
        } else {
            router.push(destination)
        }
    }

    return (
        <Button
            size="md"
            variant="solid"
            leftIcon={faIcon({ name: "plus", style: "solid" })}
            onClick={onClick}
            noDebounce={true}
        >
            {isDesktop ? "New" : null}
        </Button>
    )
}
